module.exports = __webpack_public_path__ + "img/logo.747d7732.png";